import { useSelector } from 'react-redux';
import { useOutlet } from 'react-router-dom';
import AuthPage from '../Pages/AuthPage';
import ServiceSetup from '../Pages/ServiceSetupPage';
import AppPageComponent from './AppPageComponent';

/**
 * A layout component that wraps every page within the Web App requiring authentication.
 *
 * When the user is unauthenticated or we are still loading their data,
 * we render the log in page instead of the requested page component.
 *
 * Note if you are changing this behaviour, many of our components are written
 * assuming user data is present on the state.
 */
export const AuthRequiredLayout = () => {
  const isAuthenticated = useSelector((state) => state.authentication.isAuthenticated);
  const isUserReady = useSelector((state) => state.user.isUserReady);
  const mustChangePassword = useSelector((state) => !!state.authentication.mustChangeMessage);
  const databaseConfigured = useSelector((state) => state.serviceSetup.isDatabaseConfigured);
  const showLogin = !isAuthenticated || !isUserReady || mustChangePassword;
  const outlet = useOutlet();

  if (!databaseConfigured) {
    return (
      <AppPageComponent pageTitle="Connect">
        <ServiceSetup />
      </AppPageComponent>
    );
  }

  if (showLogin) {
    return (
      <AppPageComponent pageTitle="Log In">
        <AuthPage />
      </AppPageComponent>
    );
  }

  return outlet;
};
